import AsyncStorage from '@react-native-async-storage/async-storage';
import vars from '../env'

export const AUTHENTICATE = 'AUTHENTICATE';
export const LOGOUT = 'LOGOUT';
export const VERIFY = 'VERIFY';

let timer

export const authenticate = (userId, token, expiryTime) => {
     return dispatch => {
         dispatch(setLogoutTimer(expiryTime));
         dispatch({ type: AUTHENTICATE, userId: userId, token: token})
     }
}

export const signup = (email, password) => {
    return async dispatch => {
        const response = await fetch(`https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=${vars.firebaseApiKey}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json' 
            },
            body: JSON.stringify({
                email: email,
                password: password,
                returnSecureToken: true
            })
        }
        );
        
        if (!response.ok) {
            const errorResData = await response.json()
            const errorId = errorResData.error.message;
            let message = 'Something went wrong'
            if (errorId === 'EMAIL_EXISTS') {
                message = 'This email address is already in use by another account'
            } else if (errorId === 'TOO_MANY_ATTEMPTS_TRY_LATER') {
                message = 'We have blocked all requests from this device due to unusual activity. Try again later'
            }
            throw new Error(message)
        }

        const resData = await response.json()
        dispatch(authenticate(resData.localId, resData.idToken, parseInt(resData.expiresIn) * 1000));
        dispatch(requestVerified(resData.idToken));
        const expirationDate = new Date(new Date().getTime() + parseInt(resData.expiresIn) * 1000)
        saveDataToStorage(resData.idToken, resData.localId, expirationDate);
        dispatch(confirmEmail(resData.idToken));
    }
};

export const login = (email, password) => {
    return async dispatch => {
        const response = await fetch(`https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${vars.firebaseApiKey}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json' 
            },
            body: JSON.stringify({
                email: email,
                password: password,
                returnSecureToken: true
            })
        }
        );
        
        if (!response.ok) {
            const errorResData = await response.json();
            const errorId = errorResData.error.message;
            let message = 'Something went wrong'
            if (errorId === 'EMAIL_NOT_FOUND') {
                message = 'The password or email address you have entered is incorrect'
            } else if (errorId === 'INVALID_PASSWORD') {
                message = 'The password or email address you have entered is incorrect'
            } else if (errorId === 'INVALID_EMAIL') {
                message = 'The password or email address you have entered is incorrect'
            }
            throw new Error(message)
        }

        const resData = await response.json()
        dispatch(authenticate(resData.localId, resData.idToken, parseInt(resData.expiresIn) * 1000))
        dispatch(requestVerified(resData.idToken));
        const expirationDate = new Date(new Date().getTime() + parseInt(resData.expiresIn) * 1000)
        saveDataToStorage(resData.idToken, resData.localId, expirationDate)
    }
};

export const setNewPassword = (password) => {
    
    return async (dispatch, getState) => {
        const token = getState().auth.token;
        const response = await fetch(`https://identitytoolkit.googleapis.com/v1/accounts:update?key=${vars.firebaseApiKey}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json' 
            },
            body: JSON.stringify({
                idToken: token,
                password: password,
                returnSecureToken: true
            }) 
        })

        if (!response.ok) {
            const errorResData = await response.json();
            const errorId = errorResData.error.message;
            let message = 'Something went wrong'
            if (errorId === 'INVALID_ID_TOKEN') {
                message = 'You have been inactive for to long, please sign in again'
            } else if (errorId === 'WEAK_PASSWORD') {
                message = 'Your password is too weak. It must be 8 characters long or more.'
            } 
            throw new Error(message)
        }

        const resData = await response.json()
        dispatch(authenticate(resData.localId, resData.idToken, parseInt(resData.expiresIn) * 1000))
        const expirationDate = new Date(new Date().getTime() + parseInt(resData.expiresIn) * 1000)
        saveDataToStorage(resData.idToken, resData.localId, expirationDate)
    }
};

export const resetPassword = (email) => {
    return async dispatch => {
        const response = await fetch(`https://identitytoolkit.googleapis.com/v1/accounts:sendOobCode?key=${vars.firebaseApiKey}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json' 
            },
            body: JSON.stringify({
                requestType: "PASSWORD_RESET",
                email: email
            })
        });

        if (!response.ok) {
            const errorResData = await response.json()
            const errorId = errorResData.error.message;
            let message = 'Something went wrong'
            if (errorId === 'EMAIL_NOT_FOUND') {
                message = 'There is no user record corresponding to this email address'
            }
            throw new Error(message)
        }

    };
};

export const confirmEmail = (token) => {
    return async dispatch => {
        const response = await fetch(`https://identitytoolkit.googleapis.com/v1/accounts:sendOobCode?key=${vars.firebaseApiKey}`, {
           method: 'POST',
           headers: {
            'Content-Type': 'application/json'
           },
           body: JSON.stringify({
               requestType: 'VERIFY_EMAIL',
               idToken: token
           })
        })

        if(!response.ok) {
            const errorResData = await response.json()
            const errorId = errorResData.error.message;
            console.log(errorId)
        }
    };
};

export const requestVerified = (token) => {
    return async dispatch => {
        const response = await fetch(`https://identitytoolkit.googleapis.com/v1/accounts:lookup?key=${vars.firebaseApiKey}`,{
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              idToken: token
            })
          })
    
          if(!response.ok) {
            const errorResData = await response.json()
            const errorId = errorResData.error.message;
            console.log(errorId)
          }
    
          const resData = await response.json();
          const isVerified = resData.users[0].emailVerified
          dispatch({ type: VERIFY, isVerified: !isVerified})
    }
}


export const logout = () => {
        clearLogoutTimer();
        AsyncStorage.removeItem('userData');
        return { type: LOGOUT}
};

const clearLogoutTimer = () => {
    if (timer) {
        clearTimeout(timer);
    }
}


const setLogoutTimer = expirationTime => {
    return dispatch => {
        timer = setTimeout(() => {
            dispatch(logout())
        }, expirationTime)
    }   
};

const saveDataToStorage = (token, userId, expirationDate) => {
    AsyncStorage.setItem('userData', JSON.stringify({
        token: token,
        userId: userId,
        expiryDate: expirationDate.toISOString()
    }))
}